import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { MARKETING_SERVICES } from "../data/mock";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-16">
      <section className="bg-[#FDFBF7] py-24 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <motion.div {...fadeUp} className="max-w-3xl mb-16">
            <p className="uppercase text-xs tracking-[0.2em] text-[#A31621] font-semibold mb-4">Marketing Services</p>
            <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight leading-[1.05] text-[#1A1014]">
              Everything your brand needs to <span className="italic text-[#6C0B1B]">win online.</span>
            </h1>
            <p className="mt-6 text-lg text-[#5C4B51] leading-relaxed">
              Helping your business thrive online with tailored digital marketing — from search and social to lead generation and beyond. Explore any service to see exactly what's included.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {MARKETING_SERVICES.map((s, i) => (
              <motion.div key={s.slug} {...fadeUp} transition={{ ...fadeUp.transition, delay: (i % 3) * 0.1 }}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                  className="group block bg-white border border-[#6C0B1B]/10 rounded-2xl overflow-hidden h-full shadow-[0_20px_40px_-15px_rgba(108,11,27,0.08)] hover:border-[#6C0B1B]/30 transition-colors duration-300">
                  <div className="h-44 overflow-hidden relative">
                    <img src={s.heroImage} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-[#FDFBF7]/90 backdrop-blur border border-[#6C0B1B]/15 flex items-center justify-center text-[#6C0B1B]">
                      <s.icon size={20} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading text-2xl font-semibold text-[#1A1014]">{s.title}</h3>
                    <p className="mt-1 text-sm font-medium text-[#A31621]">{s.tagline}</p>
                    <p className="mt-3 text-[15px] text-[#5C4B51] leading-relaxed">{s.description}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#6C0B1B]">
                      Learn more <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          <motion.div {...fadeUp} className="mt-16 rounded-2xl bg-[#1A1014] text-white p-10 sm:p-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl font-light">Not sure where to start?</h2>
              <p className="mt-2 text-white/60">Tell us your goal — we'll map the fastest route to it.</p>
            </div>
            <Link to="/contact" data-testid="services-contact-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#6C0B1B] text-white px-7 py-3.5 font-medium hover:bg-[#8C1126] transition-colors duration-200 shrink-0">
              Get a Free Consultation <ArrowUpRight size={17} />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
